
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 8 6.49"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.33 0h3.56l-.2.53-.25.21c.41.66.81 1.18.92 1.33.19-.28.45-.63.86-1.25L4.75.51l.15-.52h2.68l-.16.55A3 3 0 006 1.26c-.27.27-.44.47-1.23 1.42.48.74 1.44 2.07 1.85 2.59a1.42 1.42 0 00.79.5l.56.21-.19.5H4.17L4.29 6l.26-.29c-.1-.19-.61-.89-1.09-1.65a12.62 12.62 0 00-1 1.55l.48.39-.2.48H.07l.17-.5.39-.16a2.21 2.21 0 00.93-.6c.28-.3.95-1.1 1.51-1.81-.82-1.28-1.31-2-1.51-2.23A1.49 1.49 0 00.67.63L.23.5z"}})])
          )
        }
      }
    